// extracted by mini-css-extract-plugin
export default {"modalContainer":"new-payment-card-modal_modalContainer__WFV5E"};